/**
 * Created by laszlo.czondor on 2017. 12. 19.
 * https://regex101.com/r/cM9mE7/2
 */

function priceFilter (value, separator = ' ', interval = 3) {
	if (value !== null && typeof(value) !== 'undefined') {
		let numberRegex = new RegExp('\\B(?=(\\d{' + interval + '})+(?!\\d))', 'g');
		return value.toString().replace(numberRegex, separator);
	} else {
		return '';
	}
}

export default priceFilter;



// WEBPACK FOOTER //
// ../source/common/price-filter/price-filter.js